import { LegacyPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import { SegmentsPaths } from "../segmentPaths";
import SegmentsPageRouter, { SegmentsRerouter } from "../SegmentsPageRouter";

import type { RegalRouteObject } from "App/routes/types";

const SegmentPage = lazyWithRetries("Segment page", () => import("./SegmentGridPage/SegmentGridPage"));
const SegmentEditPage = lazyWithRetries("Edit Add segment page", () => import("./SegmentEditPage/SegmentEditPage"));

export const audienceSegmentPageRoute: RegalRouteObject = {
    element: <SegmentsPageRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <SegmentPage />,
        },
        {
            path: SegmentsPaths.new,
            element: <SegmentEditPage />,
        },
        {
            path: SegmentsPaths.edit,
            element: <SegmentEditPage />,
        },
    ],
};

export const rerouteSegmentRoute: RegalRouteObject = {
    path: LegacyPagePaths.segment,
    element: <SegmentsRerouter />,
    children: [
        {
            path: "*",
            element: <SegmentsRerouter />,
        },
    ],
};
